export default "__VITE_ASSET__Bv1ZHa$x__"